

































































import Vue from 'vue'
import Component from 'vue-class-component';
import IMessage from '@/interfaces/message';
import { Prop } from 'vue-property-decorator';
import { request } from '@/graphql/request';
import ICommand from '../interfaces/command';
import UpdateUserPreferenceMutation from '@/graphql/mutations/updateUserPreference.gql';
import GetUserPreferenceQuery from '@/graphql/queries/getUserPreference.gql';
import ImageModal from './ImageModal.vue';
import MapModal from './MapModal.vue';

@Component({
  components: {
    ImageModal,
    MapModal,
  }
})
export default class HatsuiTableDisplay extends Vue {
  @Prop({ required: true })
  public messages!: IMessage[];

  public errorMessage = '';
  public isAliasBeingChanged: boolean = false;
  public aliases = [
    'ID',
    'S',
    'AX',
    'AY',
    'AZ',
    'DX',
    'DY',
    'DZ',
    'T1',
    'T2',
    'T3',
    'V1',
    'V2',
    'V3',
    'V4',
    'V5',
    'V6',
    'V7',
    'V8',
    'V9',
  ];
  public newAliases: string[] = this.aliases;

  private currentlyVisibleIndex = -1;
  private mapVisibleIndex = -1;

  get allCommands() {
    return this.messages.flatMap(msg => 
      msg.commands.map(command => ({
        ...command,
        message: msg,
      })
    ));
  }

  get parsedData(): Array<Array<string | number>> {
    return this.allCommands.map(cmd => this.parseHatsuiData(cmd));
  }

  public getIsImageVisible(index: number): boolean {
    return index === this.currentlyVisibleIndex;
  }

  public getTimestamp(index: number) {
    const d = new Date(this.allCommands[index].message.timestamp);
    return d.toISOString().replace('T', ' ').replace(/\..+$/, '');
  }

  public roundToDecimals(num: number | string, decimals: number) {
      if (!num) {
        return num
      };

      return +((+num).toFixed(decimals));
  }

  public mounted() {
    this.fillAliases();
  }

  public async fillAliases() {
    await request(GetUserPreferenceQuery as any, {
      key: 'hatsui_aliases',
    })
      .then(({ data, errors }) => {
        if (errors && errors.length && errors.length > 0) {
          throw new Error();
        }
        let aliases = data && data.getUserPreference && JSON.parse(data.getUserPreference);
        aliases = aliases || this.aliases;

        this.aliases = [...aliases, ...this.aliases.slice(aliases.length)];
        this.newAliases = aliases;
      })
      .catch((e: any) => {
        this.errorMessage = e;
      });
  }

  public parseHatsuiData(command: ICommand): Array<string | number> {
    if (command.name === 'hatsui_data') {
      const commandString = command.data.toString();

      return commandString
        .substr(1, commandString.length - 2)
        .split(';')
        .map(data => isNaN(data as any) ? data : this.roundToDecimals(data, 7));
    } else {
      const array = new Array(this.aliases.length).fill(null);
      let data: { [key: string]: any } = {};
      let keys: string[] = [];
      try {
        data = JSON.parse(command.data);
        keys = Object.keys(data);
      } catch(e) {
        // tslint:disable-next-line:no-console
        console.error(e);
      }

      const fileUrl = command.file
        ? `${command.file.path}?type=${command.file.type}&${this.$store.getters['auth/fileQueryParams']}`
        : null;

      let dataPopulated = false;

      keys.forEach(k => {
        const aliasIndex = this.aliases.findIndex(a => new RegExp(`^${a}$`, 'gi').test(k));
        if (aliasIndex > -1) {
          array[aliasIndex] = data[k];
          dataPopulated = true;
        } 
      });

      if (!dataPopulated && fileUrl) {
        array[1] = fileUrl;
      }
      
      array[0] = command.name;
      return array;
    }
  }

  public startChangeAlias() {
    this.isAliasBeingChanged = true;
  }

  public endChangeAlias() {
    this.isAliasBeingChanged = false;

    for (const alias in this.newAliases) {
      if (alias.length <= 0) {
        this.errorMessage = 'Alias cannot be empty.';
        return;
      }
    }

    request(UpdateUserPreferenceMutation as any, {
      key: 'hatsui_aliases',
      value: JSON.stringify(this.newAliases),
    })
      .then(({ data, errors }) => {
        if (errors && errors.length && errors.length > 0) {
          throw new Error();
        }
        this.aliases = this.newAliases;
      })
      .catch(error => {
        this.errorMessage = 'Alias change failed.';
      });
  }

  public isValidUrl(str: string): boolean {
    try {
      // tslint:disable-next-line
      new URL(str);
      return true;
    } catch (_) {
      return false;  
    }
  }

  public isImage(url: string): boolean {
    return /type\=(img|image)/gi.test(url);
  }

  public isGps(index: number, a?: string | null, b?: string | null): boolean {
    return a != null &&
      b != null &&
      index + 1 < this.aliases.length &&
      /^lat/gi.test(this.aliases[index]) &&
      /^lon/gi.test(this.aliases[index + 1]) &&
      /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/.test(
        a.toString() + ',' + b.toString()
      )
  }
}
